export default __webpack_public_path__ + "static/media/AW.ae72ffe3.svg";